<template>
  <div class="pertamina">
    <div class="pertamina__wrapper">
      <div v-if="!isLoadingSPBU && !locationEmpty" class="pertamina__form">
        <div class="pertamina__form__header">
          <h1>SPBU</h1>
          <p>Jumlah transaksi per cabang</p>
        </div>
        <div class="pertamina__form__spbu">
          <p class="title">Pilih SPBU</p>
          <adx-select-dropdown :label="`Nama SPBU`" :value.sync="spbu" :options="dropdown" :ref="'spbu'" :class="['dropdown', spbu == 0 && spbuValidation ? 'error' : '']"/>
          <div v-if="spbu == 0 && spbuValidation" class="error-message">Please select the location</div>
        </div>
        <div class="pertamina__form__transaction">
          <p class="title">Detail Transaksi</p>
          <div :class="['calendar', inputDate == null && dateValidation ? 'error' : '']">
            <label class="small-font">Pilih Tanggal</label>
            <v-date-picker
              v-model="inputDate"
              :max-date='today'
              :popoverVisibility="'focus'"
              :theme-styles='themeStyles'
              :attributes='attributes'
              class='date-input'>
              <input
                class="calendar-start"
                placeholder= "DD/MM/YYYY"
                slot-scope='{ inputValue, updateValue }'
                :value='inputValue'
                :ref="'inputValue'"
                type='text' 
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
          </div>
          <div v-if="inputDate == null && dateValidation" class="error-message">Please select date</div>
        </div>
        <div v-if="!isLoadingData" class="input-wrapper">
          <div class="pertamina__form__transaction__group">
            <p class="pertamina__form__transaction__group__title">Premium</p>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R2</p></div>
              <div :class="['right', input.premium_2 == null && fieldValidation.isValid ? 'error' : '']">
                <adx-input  :ref="dataRef.premium_2" :label="`Jumlah Transaksi`" :value.sync="input.premium_2" type="number"/>
              </div>
            </div>
            <div v-if="input.premium_2 == null && fieldValidation.isValid" class="error-message">Please input minumum 1 field!</div>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R4</p></div>
              <div class="right">
                <adx-input :ref="dataRef.premium_4" :label="`Jumlah Transaksi`" :value.sync="input.premium_4" type="number" />
              </div>
            </div>
          </div>
          <div class="pertamina__form__transaction__group">
            <p class="pertamina__form__transaction__group__title">Bio Solar</p>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R4</p></div>
              <div class="right">
                <adx-input :ref="dataRef.biosolar_4" :label="`Jumlah Transaksi`" :value.sync="input.biosolar_4" type="number"/>
              </div>
            </div>
          </div>
          <div class="pertamina__form__transaction__group">
            <p class="pertamina__form__transaction__group__title">Pertamax</p>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R2</p></div>
              <div class="right">
                <adx-input :ref="dataRef.pertamax_2" :label="`Jumlah Transaksi`" :value.sync="input.pertamax_2" type="number"/>
              </div>
            </div>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R4</p></div>
              <div class="right">
                <adx-input :ref="dataRef.pertamax_4" :label="`Jumlah Transaksi`" :value.sync="input.pertamax_4" type="number"/>
              </div>
            </div>
          </div>
          <div class="pertamina__form__transaction__group">
            <p class="pertamina__form__transaction__group__title">Pertamax Turbo</p>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R2</p></div>
              <div class="right">
                <adx-input :ref="dataRef.pertamaxturbo_2" :label="`Jumlah Transaksi`" :value.sync="input.pertamaxturbo_2" type="number"/>
              </div>
            </div>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R4</p></div>
              <div class="right">
                <adx-input :ref="dataRef.pertamaxturbo_4" :label="`Jumlah Transaksi`" :value.sync="input.pertamaxturbo_4" type="number"/>
              </div>
            </div>
          </div>
          <div class="pertamina__form__transaction__group">
            <p class="pertamina__form__transaction__group__title">Dex</p>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R4</p></div>
              <div class="right">
                <adx-input :ref="dataRef.dex_4" :label="`Jumlah Transaksi`" :value.sync="input.dex_4" type="number"/>
              </div>
            </div>
          </div>
          <div class="pertamina__form__transaction__group">
            <p class="pertamina__form__transaction__group__title">Vigas</p>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R4</p></div>
              <div class="right">
                <adx-input :ref="dataRef.vigas_4" :label="`Jumlah Transaksi`" :value.sync="input.vigas_4" type="number"/>
              </div>
            </div>
          </div>
          <div class="pertamina__form__transaction__group">
            <p class="pertamina__form__transaction__group__title">Px Racing</p>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R4</p></div>
              <div class="right">
                <adx-input :ref="dataRef.pxracing_4" :label="`Jumlah Transaksi`" :value.sync="input.pxracing_4" type="number"/>
              </div>
            </div>
          </div>
          <div class="pertamina__form__transaction__group">
            <p class="pertamina__form__transaction__group__title">Pertalite</p>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R2</p></div>
              <div class="right">
                <adx-input :ref="dataRef.pertalite_2" :label="`Jumlah Transaksi`" :value.sync="input.pertalite_2" type="number"/>
              </div>
            </div>
            <div class="pertamina__form__transaction__group__row">
              <div class="left"><p>R4</p></div>
              <div class="right">
                <adx-input :ref="dataRef.pertalite_4" :label="`Jumlah Transaksi`" :value.sync="input.pertalite_4" type="number"/>
              </div>
            </div>
          </div>
          <div class="pertamina__submit"> 
            <button type="button" :class="['btn-large primary', isLoadingSubmit ? 'disabled' : '']" @click.stop="submit">
            Simpan
            <adx-loading-circle class="loading" v-if="isLoadingSubmit" slot="loading" /></button>
          </div>
        </div>
        <div v-else class="loading-spbu"><adx-loading slot="loading" /></div>
      </div>
      <div v-else-if="!isLoadingSPBU && locationEmpty" class="pertamina__empty">
        <div class="pertamina__empty__image">
          <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 480 388">
              <g fill="none" fill-rule="nonzero">
                  <path fill="#E7E7E7" d="M118 338.837H79.2a24.579 24.579 0 0 0-21.646 12.128 24.474 24.474 0 0 0 0 24.772A24.579 24.579 0 0 0 79.2 387.864H118c13.394-.24 24.125-11.145 24.125-24.513 0-13.368-10.731-24.272-24.125-24.514z" opacity=".64"/>
                  <path fill="#E5E5EA" d="M430.056 103.858h-76.168c-5.678-.122-10.308-4.58-10.635-10.239-.327-5.658 3.76-10.617 9.387-11.389h21.408c18.836-.286 33.955-15.605 33.955-34.405 0-18.799-15.12-34.118-33.955-34.405H177.04c-18.836.287-33.955 15.606-33.955 34.405 0 18.8 15.12 34.12 33.955 34.405h37.552c5.702.693 9.884 5.687 9.554 11.41-.33 5.723-5.058 10.206-10.802 10.242h-163.4c-27.574 0-49.93 22.3-49.944 49.817a49.79 49.79 0 0 0 14.614 35.269 49.996 49.996 0 0 0 35.33 14.612H200.4c8.888 1.11 15.523 8.706 15.412 17.645-.11 8.938-6.93 16.368-15.844 17.26H122.28c-20.514 0-37.144 16.595-37.144 37.067s16.63 37.067 37.144 37.067h90.52c7.14.176 12.836 6.002 12.836 13.13 0 7.126-5.696 12.953-12.836 13.128h-22.288c-13.394.242-24.125 11.146-24.125 24.514 0 13.368 10.731 24.272 24.125 24.513h218.096c13.394-.241 24.125-11.145 24.125-24.513 0-13.368-10.731-24.272-24.125-24.514h-51.496c-7.14-.175-12.836-6.002-12.836-13.129s5.696-12.953 12.836-13.129h46.744c20.514 0 37.144-16.595 37.144-37.067s-16.63-37.068-37.144-37.068h-63.2c-8.913-.89-15.734-8.32-15.844-17.26-.11-8.938 6.524-16.533 15.412-17.644h89.832a49.996 49.996 0 0 0 35.33-14.612A49.79 49.79 0 0 0 480 153.699c0-27.526-22.36-49.841-49.944-49.841zm-128.328 221.87c0 7.254-5.892 13.133-13.16 13.133h-11.6c-7.14-.175-12.836-6.002-12.836-13.129s5.696-12.953 12.836-13.129h11.608c7.262.005 13.148 5.879 13.152 13.125zM275.12 92.992c.002-5.502 4.125-10.135 9.6-10.785h17.792c5.702.692 9.884 5.686 9.554 11.41-.33 5.722-5.058 10.205-10.802 10.24h-15.256c-6.013 0-10.888-4.864-10.888-10.865z" opacity=".3"/>
                  <ellipse cx="421.543" cy="147.884" fill="#FF2956" opacity=".607" rx="2.88" ry="2.874" transform="rotate(-73.98 421.543 147.884)"/>
                  <path fill="#94DFFF" d="M323.944 263.002l5.888 19.959 25.136-5.325-2.56 31.327 26.032-9.46-45.6 67.86a32.803 32.803 0 0 1-20.906 13.889 32.855 32.855 0 0 1-24.622-4.94 32.73 32.73 0 0 1-13.918-20.863 32.678 32.678 0 0 1 4.95-24.571l45.6-67.876z"/>
                  <path fill="#CBEEFF" d="M352.408 308.963l2.552-31.28-25.136 5.325-1.16-3.935-38.704 57.569c-6.13 9.118-3.693 21.47 5.444 27.587 9.137 6.118 21.514 3.685 27.644-5.433l34.84-51.829-5.48 1.996z"/>
                  <path fill="#94DFFF" d="M373.928 215.516l-20.504-3.896-6.728 24.749-26.72-16.542-3.456 27.431-35.76-64.427 57.408-31.735z"/>
                  <path fill="#CBEEFF" d="M319.976 219.827l26.72 16.542 6.728-24.75 4.032.767-30.56-55.054-34.856 19.264 27.208 49.019z"/>
                  <path fill="#94DFFF" d="M337.224 153.563l-53.864 29.779a11.525 11.525 0 0 1-8.757.98 11.5 11.5 0 0 1-6.883-5.49 11.46 11.46 0 0 1-.996-8.732 11.485 11.485 0 0 1 5.484-6.877l53.864-29.778a11.525 11.525 0 0 1 8.75-.994 11.5 11.5 0 0 1 6.89 5.473 11.46 11.46 0 0 1 1.011 8.75 11.485 11.485 0 0 1-5.499 6.89z"/>
                  <path fill="#CBEEFF" d="M334.104 147.105l-29.232 16.158a6.247 6.247 0 0 1-8.488-2.395 6.22 6.22 0 0 1 2.4-8.47l29.232-16.159a6.247 6.247 0 0 1 8.488 2.395 6.22 6.22 0 0 1-2.4 8.47z" opacity=".5"/>
                  <path fill="#FF2956" d="M424.16 248.168c-8.488.224-18.944 4.966-18.944 4.966s5.888-5.054 11.64-18.889c5.752-13.835 8.392-28.014 1.424-26.912-6.968 1.101-11.736 14.53-16.288 23.096-8.056 15.169-15.072 20.023-15.072 20.023s2.872-5.373-.28-9.812c-3.152-4.439-11.472-3.281-17.344 10.961a150.45 150.45 0 0 1-14.744 26.346l-.44.63c-.49.698-.987 1.39-1.488 2.076l-.28.384c-.533.713-1.067 1.418-1.6 2.115l-.352.463a37.294 37.294 0 0 1-1.688 2.124l-.328.399a78.437 78.437 0 0 1-1.768 2.092l-.176.2a65.593 65.593 0 0 1-3.768 3.991 42.38 42.38 0 0 1-6.104 5.11c-7.904 5.269-18.08 5.9-24.168 5.708l-22.448 33.395c-6.13 9.118-3.693 21.47 5.444 27.587 9.137 6.118 21.514 3.685 27.644-5.433l34.84-51.829s23.944-30.752 54.536-43.446c16.8-6.962 28.336-3.72 29.6-8.215 1.264-4.495-9.36-7.353-17.848-7.13z" opacity=".66"/>
                  <ellipse cx="398.559" cy="208.59" fill="#FF2956" opacity=".397" rx="5.712" ry="5.7" transform="rotate(-73.99 398.559 208.59)"/>
                  <ellipse cx="387.014" cy="174.572" fill="#FF2956" opacity=".607" rx="3.352" ry="3.345" transform="rotate(-73.98 387.014 174.572)"/>
                  <path fill="#94DFFF" d="M275.96 239.506l14.8-3.584-4.288 14.585zM402.072 307.23l2.504-14.985 11.752 9.653zM296.512 259.194l3.392-7.33 4.664 6.595z"/>
                  <path fill="#000" d="M359.576 306.344l-27.2 40.453c-6.915 10.276-19.047 15.78-31.353 14.225-12.305-1.556-22.678-9.905-26.807-21.578-4.88 15.541 2.431 32.3 17.157 39.322 14.725 7.022 32.383 2.173 41.435-11.38l45.6-67.86-18.832 6.818zM346.696 236.369l-.584-.607c-20.512-13.269-32.8-39.646-44.152-62.703l-20.36 11.265 34.936 62.934L320 219.827l26.696 16.542z" opacity=".1"/>
                  <path fill="#EC1F43" d="M386.52 271.257s-25.6 18.769-39.512 37.89c-13.912 19.12-24.8 38.24-32.4 43.366-9.04 6.092-18.512 0-19.2-7.448-.688-7.45 8.8-19.768 24.36-25.165 15.56-5.396 37.432-24.629 44.592-35.454 7.16-10.826 7.504-22.746 14.656-23.233 7.152-.487 2.456 6.85 2.456 6.85s8.8-5.07 16.464-17.005c7.664-11.935 8.928-17.268 12.352-13.667 3.424 3.6-11.96 24.47-23.768 33.866z" opacity=".483"/>
                  <path fill="#EC1F43" d="M395.904 268.407s8.752-5.054 15.792-8.08c7.04-3.026 15.936-2.714 17.416-4.95 1.48-2.235-10.32-1.692-19.64 2.914-9.32 4.607-13.568 10.116-13.568 10.116zM352.208 294.29s-9.072 9.268-19.936 14.84c-10.864 5.573-15.544 5.733-14.936 2.164.664-3.872 20-4.99 34.872-17.005z" opacity=".2"/>
                  <ellipse cx="377.626" cy="247.246" fill="#FFF" opacity=".1" rx="1.96" ry="1.956" transform="rotate(-73.99 377.626 247.246)"/>
                  <path fill="#FFF" d="M411.664 253.733a38.264 38.264 0 0 1 14.608-3.585c7.84-.167 13.312 1.294 13.168 3.25-.144 1.955-4.592-1.334-12.88-1.693a42.906 42.906 0 0 0-14.896 2.028zM367.848 263.026s-6.544 14.929-14.4 23.607a66.551 66.551 0 0 1-15.328 12.83s10.256-2.5 18.76-13.03c8.504-10.53 10.968-23.407 10.968-23.407zM415.832 212.29s-2.576 2.132-5.72 8.654c-3.144 6.523-6.072 13.804-11.008 20.23a75.232 75.232 0 0 1-8.704 9.757s6.728-2.898 14.08-14.794c7.352-11.895 5.4-15.791 11.352-23.847z" opacity=".1"/>
                  <ellipse cx="397.609" cy="206.985" fill="#FFF" opacity=".1" rx="2.36" ry="2.355" transform="rotate(-73.99 397.609 206.985)"/>
                  <ellipse cx="386.427" cy="173.478" fill="#FFF" opacity=".397" rx="1.544" ry="1.541" transform="rotate(-73.99 386.427 173.478)"/>
                  <ellipse cx="421.496" cy="146.95" fill="#FFF" opacity=".397" rx="1.136" ry="1.134" transform="rotate(-73.98 421.496 146.95)"/>
                  <path fill="#FFF" d="M357.904 306.951l-5.496 1.996 2.552-31.28-25.128 5.326-1.16-3.936-4.728-16.055-15.432 22.96 41.52 55.79 28.408-42.258-20.536 7.457z" opacity=".05"/>
                  <path fill="#FFF" d="M296.072 304.46l-17.76 26.418c-.472.702-.888 1.429-1.296 2.155l35.728 48.013a32.673 32.673 0 0 0 20.056-13.683l4.8-7.106-41.528-55.797z" opacity=".1"/>
                  <path fill="#00C8FB" d="M271.304 60.284S282.856 48.117 294 46.249c18.056-3.034 21.096 13.987 14.4 19.112-6.696 5.126-20.472-8.27-37.096-5.077zM269.256 46.752s-.504-8.982 2.872-14.012c5.472-8.15 13.24-3.065 12.8 1.438-.44 4.502-10.792 4.941-15.672 12.574z" opacity=".596"/>
                  <ellipse cx="163.249" cy="187.179" fill="#94DFFF" rx="83.736" ry="83.564" transform="rotate(-57.54 163.25 187.179)"/>
                  <path fill="#94DFFF" d="M207.91 56.002l55.378 35.226-56.608 88.993-55.378-35.226z"/>
                  <path fill="#94DFFF" d="M260.712 91.54l-51.96-32.98a11.48 11.48 0 0 1-5.06-7.197 11.46 11.46 0 0 1 1.524-8.659 11.504 11.504 0 0 1 7.211-5.05 11.524 11.524 0 0 1 8.677 1.521l51.96 32.98a11.48 11.48 0 0 1 5.06 7.197 11.46 11.46 0 0 1-1.524 8.659 11.504 11.504 0 0 1-7.211 5.05c-2.98.662-6.102.114-8.677-1.522z"/>
                  <path fill="#CBEEFF" d="M238.976 67.301L213.12 50.887A5.71 5.71 0 0 1 211.36 43a5.735 5.735 0 0 1 7.904-1.756l25.856 16.414a5.71 5.71 0 0 1 1.76 7.888 5.735 5.735 0 0 1-7.904 1.756z" opacity=".5"/>
                  <path fill="#CBEEFF" d="M252.456 84.29l-33.6-21.34-39.008 61.194c-31.124-8.16-63.566 7.518-76.448 36.947-12.882 29.428-2.364 63.835 24.784 81.077 27.148 17.243 62.836 12.181 84.096-11.926 21.26-24.107 21.755-60.076 1.168-84.758l39.008-61.194z"/>
                  <path fill="#00A4CE" d="M97.952 187.078s20.976-15.057 45.544-8.941c23.48 5.844 36.8 6.69 52.592 2.043 15.792-4.646 2.968 33.204-37.72 31.504-40.688-1.701-60.688-18.65-60.416-24.606z"/>
                  <path fill="#00C8FB" d="M213.448 145.484s-7.984-11.52-18.248-10.562c-10.264.958.96 13.396.96 13.396s-17.376-17.604-23.648-12.773c-4.952 3.824 2.24 8.614 8.952 16.581.245.293.49.596.736.91 8.56 11.074 5.84 27.144-5.544 35.264-5.648 4.04-13.208 7.329-23.632 9.333-14.824 2.85-37.928 0-55.096-10.57-.05 23.248 12.327 44.758 32.472 56.435 29.088 16.925 66.904 8.678 86.248-18.825 16.979-24.088 15.667-56.544-3.2-79.189z"/>
                  <ellipse cx="158.368" cy="152.989" fill="#00AFFF" rx="4.68" ry="4.67"/>
                  <ellipse cx="252.456" cy="28.429" fill="#00C8FB" opacity=".596" rx="4.68" ry="4.67"/>
                  <ellipse cx="139.784" cy="155.376" fill="#00AFFF" rx="2.4" ry="2.395"/>
                  <ellipse cx="229.544" cy="2.467" fill="#00C8FB" opacity=".596" rx="2.4" ry="2.395"/>
                  <path fill="#94DFFF" d="M110.264 173.155a3.2 3.2 0 0 1-2.948-1.786 3.188 3.188 0 0 1 .388-3.42l10.224-13.212-7.584-20.015a3.225 3.225 0 0 1 .523-3.188 3.24 3.24 0 0 1 5.533.905l8.224 21.7a3.188 3.188 0 0 1-.464 3.113l-11.36 14.65a3.202 3.202 0 0 1-2.536 1.253z"/>
                  <path fill="#94DFFF" d="M128.064 170.736a3.205 3.205 0 0 1-1.768-.527l-10.576-6.914a3.226 3.226 0 0 1-.936-4.47 3.24 3.24 0 0 1 4.48-.935l10.576 6.914a3.19 3.19 0 0 1 1.424 3.656 3.2 3.2 0 0 1-3.2 2.276z"/>
                  <path fill="#000" d="M136.744 225.886c-31.909-20.263-46.252-59.352-35-95.387-23.328 25.208-28.844 62.085-13.908 92.993 14.935 30.907 47.286 49.561 81.577 47.04 34.291-2.522 63.552-25.707 73.787-58.465-27.472 29.683-72.289 35.5-106.456 13.82z" opacity=".1"/>
                  <path fill="#427380" d="M219.368 189.849s-3.112 40.644-44.176 52.22-62.104-14.834-59.272-25.452c2.832-10.618 18.544-9.971 44 4.838 23.808 13.884 55.136-12.23 59.448-31.606z" opacity=".32"/>
                  <path fill="#000" d="M174.32 200.634s18.344-5.588 20.496-20.446c2.152-14.857-5.936-20.262 0-22.53 5.936-2.266 22.392 37.069-20.496 42.976z" opacity=".1"/>
                  <path fill="#FFF" d="M223.144 181.354a76.664 76.664 0 0 0-6.672-23.583c-5.664-11.864-11.136-17.692-14.568-16.997-3.432.694 3.24 9.476 9.312 16.59 6.072 7.113 11.928 23.99 11.928 23.99z" opacity=".1"/>
                  <path fill="#FFF" d="M208.576 197.992S200 210.59 186.68 215.643c0 0-16.936 5.804-19.152-.902-2.4-7.24 8.896-6.211 17.792-6.945 8.896-.735 23.256-9.804 23.256-9.804z" opacity=".24"/>
                  <ellipse cx="177.96" cy="140.119" fill="#FFF" opacity=".1" rx="2.768" ry="2.762"/>
                  <ellipse cx="150.976" cy="205.209" fill="#FFF" opacity=".1" rx="1.872" ry="1.868"/>
                  <ellipse cx="303.84" cy="54.272" fill="#FFF" opacity=".596" rx="4.52" ry="4.511"/>
                  <ellipse cx="278.44" cy="32.916" fill="#FFF" opacity=".596" rx="2.56" ry="2.555"/>
                  <ellipse cx="157.576" cy="151.919" fill="#FFF" opacity=".1" rx="2.368" ry="2.363"/>
                  <ellipse cx="139.024" cy="154.921" fill="#FFF" opacity=".1" rx="1" ry="1"/>
                  <path fill="#FFF" d="M139.608 107.035A83.36 83.36 0 0 0 94.4 139.632l132.912 101.391a84.228 84.228 0 0 0 6.608-8.957 83.026 83.026 0 0 0 13.064-43.112l-107.376-81.919zM211.584 255.473L84.576 158.57A83.045 83.045 0 0 0 80 195.71l96.92 73.92a84 84 0 0 0 34.664-14.156zM273.064 72.163l-51.96-32.98a11.515 11.515 0 0 0-13.828 1.115 11.456 11.456 0 0 0-2.684 13.583l55.528 42.313 2.4-3.76c5.51 2.245 11.825-.073 14.564-5.346 2.738-5.273.995-11.76-4.02-14.957v.032zM232.304 139.872l16.496-25.86-52.336-39.917-17.44 27.352 56.056 42.752a109.771 109.771 0 0 0-2.776-4.327z" opacity=".1"/>
                  <path fill="#FFB541" d="M304.312 103.674h-1.6v-1.596a3.36 3.36 0 0 0-1.633-3.047 3.374 3.374 0 0 0-3.462 0 3.36 3.36 0 0 0-1.633 3.047v1.596h-1.6a3.37 3.37 0 0 0-3.053 1.63 3.355 3.355 0 0 0 0 3.455 3.37 3.37 0 0 0 3.053 1.63h1.6v1.596a3.365 3.365 0 0 0 3.364 3.197 3.365 3.365 0 0 0 3.364-3.197v-1.597h1.6a3.364 3.364 0 0 0 3.204-3.357c0-1.792-1.41-3.27-3.204-3.357zM108.232 66.663h-1.6v-1.597a3.36 3.36 0 0 0-1.633-3.047 3.374 3.374 0 0 0-3.462 0 3.36 3.36 0 0 0-1.633 3.047v1.597h-1.6A3.364 3.364 0 0 0 95.1 70.02c0 1.792 1.41 3.27 3.204 3.357h1.6v1.596a3.36 3.36 0 0 0 1.633 3.047 3.374 3.374 0 0 0 3.462 0 3.36 3.36 0 0 0 1.633-3.047v-1.596h1.6a3.364 3.364 0 0 0 3.204-3.357c0-1.793-1.41-3.27-3.204-3.357zM418.056 338.398h-1.6v-1.596a3.36 3.36 0 0 0-1.633-3.047 3.374 3.374 0 0 0-3.462 0 3.36 3.36 0 0 0-1.633 3.047v1.596h-1.6a3.364 3.364 0 0 0-3.204 3.357c0 1.793 1.41 3.27 3.204 3.357h1.6v1.597a3.365 3.365 0 0 0 3.364 3.197 3.365 3.365 0 0 0 3.364-3.197v-1.597h1.6a3.364 3.364 0 0 0 3.204-3.357c0-1.792-1.41-3.27-3.204-3.357zM102.944 292.285h-1.6v-1.596a3.36 3.36 0 0 0-1.633-3.047 3.374 3.374 0 0 0-3.462 0 3.36 3.36 0 0 0-1.633 3.047v1.596h-1.6a3.364 3.364 0 0 0-3.204 3.357c0 1.793 1.41 3.27 3.204 3.358h1.6v1.596a3.365 3.365 0 0 0 3.364 3.198 3.365 3.365 0 0 0 3.364-3.198V299h1.6a3.364 3.364 0 0 0 3.204-3.358c0-1.792-1.41-3.27-3.204-3.357z" opacity=".439"/>
                  <ellipse cx="158.368" cy="66.543" fill="#94DFFF" opacity=".596" rx="3.48" ry="3.473"/>
                  <ellipse cx="208.576" cy="350.094" fill="#94DFFF" rx="7.76" ry="7.744"/>
                  <ellipse cx="341.72" cy="116.176" fill="#00C8FB" opacity=".596" rx="4.872" ry="4.862"/>
                  <ellipse cx="42.704" cy="161.036" fill="#00C8FB" opacity=".596" rx="4.872" ry="4.862"/>
                  <ellipse cx="372.344" cy="374.364" fill="#94DFFF" rx="5.104" ry="5.093"/>
                  <path fill="#FFB541" d="M256.8 263.153c.869-1.288 1-2.935.345-4.344a4.447 4.447 0 0 0-3.545-2.545l-12.296-1.397a4.445 4.445 0 0 0-4.513 3.932 4.44 4.44 0 0 0 3.505 4.85l12.336 1.404a4.452 4.452 0 0 0 4.168-1.9zM260.848 280.725a4.423 4.423 0 0 0-.126-5.184 4.445 4.445 0 0 0-4.97-1.514l-24.352 8.191a4.426 4.426 0 1 0-1.678 7.648 4.447 4.447 0 0 0 4.518.735l24.352-8.191a4.423 4.423 0 0 0 2.256-1.685zM269.712 294.217a4.433 4.433 0 0 0-.97-5.942 4.455 4.455 0 0 0-6.014.49l-10.4 11.496a4.428 4.428 0 0 0-.927 4.337 4.45 4.45 0 0 0 7.527 1.603l10.4-11.497c.14-.153.268-.315.384-.487z" opacity=".439"/>
              </g>
          </svg>
        </div>
        <div class="pertamina__empty__title">
          Forbidden access
        </div>
        <div class="pertamina__empty__code">
          You don't have any access to open this page
        </div>
        <div class="pertamina__action">
          <button class="btn-large primary" @click="gotoHome">Back to home</button>
        </div>
      </div>
      <div v-else class="loading-state"><adx-loading slot="loading" /></div>
    </div>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import Input from '@/components/Form/Input'
import Loading from '@/components/Loading/Primary'
import LoadingCircle from '@/components/Loading/Secondary-white'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import moment from 'moment';
import calendar from 'v-calendar'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-pertamina-form',
  components: {
    'adx-select-dropdown': SelectDropdown,
    'adx-input': Input,
    'adx-loading': Loading,
    'adx-loading-circle': LoadingCircle
  },
  props: {

  },
  data() {
    return {
      dataRef: {
        premium_2: 'premium_2',
        premium_4: 'premium_4',
        pertamaxturbo_2: 'pertamaxturbo_2',
        pertamaxturbo_4: 'pertamaxturbo_4',
        pertamax_2: 'pertamax_2',
        pertamax_4: 'pertamax_4',
        pertalite_2: 'pertalite_2',
        pertalite_4: 'pertalite_4',
        biosolar_4: 'biosolar_4',
        dex_4: 'dex_4',
        vigas_4: 'vigas_4',
        pxracing_4: 'pxracing_4'
      },
      value:null,
      spbuValidation:'',
      dateValidation:'',
      fieldValidation:'',
      spbu: 0,
      inputDate: null,
      dropdown: [],
      isLoadingSPBU: false,
      isLoadingData: false,
      isLoadingSubmit: false,
      listValue:[],
      isComplete: false,
      dataEmpty: false,
      isDateEmpty: true,
      id: null,
      locationEmpty: null,
      input: {
        premium_2: null,
        premium_4: null,
        pertamaxturbo_2: null,
        pertamaxturbo_4: null,
        pertamax_2: null,
        pertamax_4: null,
        pertalite_2: null,
        pertalite_4: null,
        biosolar_4: null,
        dex_4: null,
        vigas_4: null,
        pxracing_4: null,
      },
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      attributes: [
        {
          dot: {
            backgroundColor: '#ff3b30',
          },
          dates: [],
        },
      ],
    }
  },
  computed: {
    today() {
      var today = new Date();
      today.setDate(today.getDate() - 1)
      return today
    }
  },
    isComplete(){
      return this.input
    },
  watch: {
    spbu: function () {
      this.getInputedDate()
      if (this.inputDate) {
        this.getInputedData()
      }
    },
    inputDate: function () {
      if (this.spbu != 0) {
        this.getInputedData()
      }
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.initialLoad()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    initialLoad() {
      (async () => {
        this.isLoadingSPBU = true
        this.dropdown = []
        const response = await api.get(apiV2.pertaminaLocations, { needToken: true })
        if (response.status == 200 ) {
          const { data } = response
          if (data.length) {
            data[0].locations.map(obj => {
              this.dropdown.push({
                "label": obj.title,
                "value": obj.id
              })
            })
          } else {
            this.locationEmpty = true
          }
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'warn'
          });
        }
        this.isLoadingSPBU = false
      })();
    },
    getInputedData() {
      (async () => {
        this.isLoadingData = true
        let convertedDate = moment(this.inputDate, 'DD-MMM-YYYY').format('YYYY-MM-DD')
        const params = {
          date: convertedDate,
          location: this.spbu
        }
        const response = await api.get(apiV2.pertaminaList, { params: params, needToken: true })
        if (response.status == 200) {
          const { data } = response
          if (!data[0]) {
            this.dataEmpty = true
            this.id = null
            this.assignEmptyField(data[0])
          } else {
            this.dataEmpty = false
            this.id = data[0].id
            this.assignEmptyField(data[0])
          }
        }
        this.isLoadingData = false
      })();
    },
    getInputedDate() {
      (async () => {
        this.isLoadingData = true
        this.attributes[0].dates = []
        let params = {
          location: this.spbu
        }
        const response = await api.get(apiV2.pertaminaDates, { params: params, needToken: true })
        if (response.status == 200) {
          const { data } = response
          data.map(obj => {
            this.attributes[0].dates.push(obj.date)
          })
        }
        this.isLoadingData = false
      })();
    },
    submit() {
      (async () => {
        this.isLoadingSubmit = true
        let spbuValidation = this.validate_Spbu()
        this.spbuValidation = this.validate_Spbu()
        let dateValidation = this.date_Validate()
        this.dateValidation = this.date_Validate()
        let fieldValidation = this.field_Validate()
        this.fieldValidation = this.field_Validate()
        if(!dateValidation && !fieldValidation.isValid && !spbuValidation){
              let convertedDate = moment(this.inputDate, 'DD-MMM-YYYY').format('YYYY-MM-DD')
              let data = {
                location: this.spbu,
                date: convertedDate,
                premium_2: Number(this.input.premium_2),
                premium_4: Number(this.input.premium_4),
                pertamaxturbo_2: Number(this.input.pertamaxturbo_2),
                pertamaxturbo_4: Number(this.input.pertamaxturbo_4),
                pertamax_2: Number(this.input.pertamax_2),
                pertamax_4: Number(this.input.pertamax_4),
                pertalite_2: Number(this.input.pertalite_2),
                pertalite_4: Number(this.input.pertalite_4),
                biosolar_2: Number(this.input.biosolar_2),
                biosolar_4: Number(this.input.biosolar_4),
                dex_4: Number(this.input.dex_4),
                vigas_4: Number(this.input.vigas_4),
                pxracing_4: Number(this.input.pxracing_4),
              }
              if(this.dataEmpty) {
                const response = await api.post(apiV2.pertaminaList, data, { needToken: true })
                this.isLoadingSubmit = false
                  if (response.status == 201) {
                    this.$notify({
                    group: 'saved',
                    title: 'Save success',
                    text: 'Data successfully saved!',
                    type: 'success'
                    });
                  } else {
                    this.$notify({
                      group: 'saved',
                      title: 'Save error',
                      text: 'Oops data can not be saved!',
                      type: 'danger'
                    });
                    }
                    this.isLoadingSubmit = false
              } else {
                const response = await api.patch(apiV2.pertaminaDetail(this.id), data, { needToken: true })
                this.isLoadingSubmit = false
                  if (response.status == 200) {
                    this.$notify({
                      group: 'saved',
                      title: 'Save success',
                      text: 'Data successfully saved!',
                      type: 'success'
                    });}
                    } 
          }else if(!dateValidation && !spbuValidation) {
            this.$notify({
              group: 'saved',
              title: 'Save error',
              text: 'Error! please input minimum 1 field',
              type: 'danger'
            });
          }else if(!spbuValidation && !fieldValidation.isValid){
            this.$notify({
              group: 'saved',
              title: 'Save error',
              text: 'Please select date!',
              type: 'danger'
            });
          }else if(!dateValidation && !fieldValidation.isValid){
            this.$notify({
              group: 'saved',
              title: 'Save error',
              text: 'Please select the Location!',
              type: 'danger'
            });
          }else {
            this.$notify({
              group: 'saved',
              title: 'Save error',
              text: 'You can not leave this empty!',
              type: 'danger'
            });
            this.isLoadingSubmit = false
          }
        this.isLoadingSubmit = false
        this.getInputedDate()
      })();
    },
    assignEmptyField(data) {
      if (!data) {
        for (let key in this.input) {
          this.input[key] = null
        }
      } else {
        for (let key in this.input) {
          this.input[key] = data[key]
        }
      }
    },
    gotoHome() {
      this.$router.push({name: 'home'})
    },
    validate_Spbu(){
      let isSpbuEmpty = false
      if (this.$refs.spbu.value == 0) {
        isSpbuEmpty = true
      }
      return isSpbuEmpty
    },
    date_Validate(){
      let isDateEmpty = true
      if (this.$refs.inputValue.value) {
        isDateEmpty = false
      }
      return isDateEmpty
    },
    field_Validate() {
      let data = { isValid: false, id: null }
      let dataRef = this.dataRef

      let listValue = []
      for (let key in this.dataRef) {
        const value = this.$refs[dataRef[key]].value
        if (value) {
          listValue.push(dataRef[key])
        }
      }

      if (listValue.length == 0 ) {
        data.isValid = true
      }
      return data
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.selectDropdown {

  .select {
    .standardInput {
      padding: 16px !important;
    }
  }

  .popup {
    max-height: 300px;
    overflow-y: auto !important;
  }
}
</style>
